import React from 'react'
import FloodCustomRadio from './FloodsCustomRadio/FloodCustomRadio';

function FloodsCustomRadiogroup(props) {
  const {
    className, name, radios, selectedValue, onChange, disabled,
  } = props;

  return (
    <div className={`radiogroup ${className || ''}`}>
      { 
        radios.map((radio) => {
          return (
            <FloodCustomRadio 
              key={radio.value}
              name={name}
              label={radio.label}
              value={radio.value}
              checked={selectedValue === radio.value}
              onChange={e => onChange(e.target.value)}
              disabled={disabled}
              selectedValue={selectedValue}
            />
          );
        }) 
      }
    </div>
  );
}

export default FloodsCustomRadiogroup